import waste from '../../Assets/Images/Home/home-waste.svg';
import market from '../../Assets/Images/Home/home-market.svg';
import { useTranslation } from 'react-i18next';
import listShape from '../../Assets/Images/Home/home-list.png';

const WasteAndMarketItem = ({ img, title, list }) => {
  return (
    <div className="home__waste-and-market--item">
      <img src={img} alt={title} loading="lazy" />
      <h3>{title}</h3>
      <ul>
        {list.map((item, index) => (
          <div
            key={index}
            style={{ display: 'flex', gap: '8px', alignItems: 'center' }}
          >
            <img
              src={listShape}
              className="home__waste-and-market--item__list-shape"
              alt="shape"
              loading="lazy"
            />
            <li>{item}</li>
          </div>
        ))}
      </ul>
    </div>
  );
};

export default function WasteAndMarket() {
  const { t } = useTranslation();
  return (
    <section className="home__waste-and-market">
      <WasteAndMarketItem
        img={waste}
        list={t('home.marketAndWaste.waste.list', { returnObjects: true })}
        title={t('home.marketAndWaste.waste.title')}
      />
      <WasteAndMarketItem
        img={market}
        list={t('home.marketAndWaste.market.list', { returnObjects: true })}
        title={t('home.marketAndWaste.market.title')}
      />
    </section>
  );
}
